<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('my_course_schedule')"
                        :isFilter="false"/>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('my_course_schedule')"
                              :isFilter="false"/>
            </template>
            <b-form-group :label="$t('date')">
                <select-date v-model="selectedDate"></select-date>
            </b-form-group>
            <vue-cal :selected-date="startDate"
                     :time-cell-height="30"
                     :time-step="60"
                     :disable-views="['years', 'year', 'month','days','day']"
                     active-view="week"
                     :hide-weekdays="[]"
                     hide-title-bar
                     :events="events"
                     locale="en"
                     :time-from="8 * 60"
                     :time-to="20 * 60"
                     :on-event-click="showVueCalModal"
            >
            </vue-cal>
            <CommonModal ref="vueCalModal" size="sm">
                <template v-slot:CommonModalTitle>
                    <i style="font-size: 24px;" class="ri-calendar-event-line"></i>
                </template>
                <template v-slot:CommonModalContent>
                    <div>
                        <b-row>
                            <b-col md="12" class="mb-2">{{selectedEvent.date}}</b-col>
                            <b-col md="12" class="mb-2">{{selectedEvent.title}}</b-col>
                            <b-col md="12" class="mb-2">{{selectedEvent.start_time}} - {{selectedEvent.end_time}}</b-col>
                            <b-col md="12" v-html="selectedEvent.content"></b-col>
                        </b-row>
                    </div>
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
    import AppLayout from '@/layouts/AppLayout'
    import Header from '@/layouts/AppLayout/Header'
    import HeaderMobile from '@/layouts/AppLayout/HeaderMobile'

    import VueCal from 'vue-cal'
    import 'vue-cal/dist/vuecal.css'
    import '/src/locales/en/vuecal.js'
    import moment from 'moment';
    import CommonModal from "@/components/elements/CommonModal";

    // Services

    import SessionSchedulesInstructorSevices from "@/services/SessionSchedulesInstructorSevices";

    export default {
        components: {
            AppLayout,
            Header,
            HeaderMobile,
            VueCal,
            CommonModal
        },
        data() {
            return {
                startDate: null,
                events: [],
                selectedEvent: {},
                selectedDate: moment().format('MM/DD/YYYY'),
            }
        },
        metaInfo() {
            return {
                title: this.$t('my_course_schedule')
            }
        },
        watch: {
            selectedDate(newVal) {
                this.startDate = moment(newVal).startOf('week').add(+1, 'days').format('MM/DD/YYYY');
                this.events = [];
                this.getData();
            }
        },
        methods: {
            getData() {
                const formData = {
                        date: this.selectedDate,
                };
                SessionSchedulesInstructorSevices.sessionSchedule(formData)
                                     .then(response => {
                                         response.data.data.forEach(item => {
                                             this.events.push({
                                                 start: moment(item.date, 'MM/DD/YYYY').format('MM/DD/YYYY') + ' ' + item.start_time,
                                                 end: moment(item.date, 'MM/DD/YYYY').format('MM/DD/YYYY') + ' ' + item.end_time,
                                                 title: item.classroom,
                                                 content: item.course_name
                                             })
                                         })
                                     })
                                     .catch(e => {
                                         this.showErrors(e)
                                     })
            },
            showVueCalModal(event, e){
                this.selectedEvent = event
                moment.locale('en')
                this.selectedEvent.date = moment(event.start).format("DD-MM-YYYY")
                this.selectedEvent.start_time = moment(event.start).format("LT")
                this.selectedEvent.end_time = moment(event.end).format("LT")
                this.$refs.vueCalModal.$refs.commonModal.show()
                e.stopPropagation()
            }
        },
        created() {
            this.startDate = moment().startOf('week').add(+1, 'days').format('MM/DD/YYYY');
            this.getData()
        }
    }
</script>
